<template>
	<div class="list-warehouse">
		<div class="box">
			<span class="title">فیلترها</span>
			<div class="row mt-3 w-100">
				<div class="col-lg-6 col-sm-12">
					<div class="d-flex flex-column">
						<label for="html">نوع کالا:</label>
						<select v-model="pickTypes" class="form-select w-50">
							<option v-for="types in wareType" :value="types.id" :key="types.id">
								{{ types.verbose_name }}
							</option>
						</select>
					</div>
				</div>
				<div class="d-flex justify-content-end align-items-end col-lg-6 col-sm-12">
					<button @click="getData((limit = 20), (offset = 0))" class="accept">تایید</button>
					<button class="remove-filtes" @click="removeFilter">حذف فیلتر</button>
				</div>
			</div>
		</div>
		<div class="box">
			<pagination v-model="page" :per-page="20" :records="totalDataCount" @paginate="myCallback" />
			<Tableview
				:hover="true"
				:bordered="true"
				:showNoContent="showContnetFunc"
				:showNoData="showDataFunc"
			>
				<template #TableTitle>
					<tr>
						<th>ردیف</th>
						<th>نام انگلیسی</th>
						<th>نام فارسی</th>
						<th>کد کالا</th>
						<th>نوع کالا</th>
						<th>مصرفی</th>
						<th>موجودی</th>
						<th>توضیحات</th>
						<th>فعال/غیرفعال</th>
						<th>عملیات</th>
					</tr>
				</template>

				<template #TableBody>
					<tr v-for="(item, index) in getDataLists" :key="item.id">
						<td class="persian-number">
							{{ index + 1 }}
						</td>
						<td>{{ item.name_en }}</td>
						<td>{{ item.name_fa }}</td>
						<td>{{item.identifier}}</td>
						<td>{{ item.type.verbose_name }}</td>
						<td v-if="item.is_for_use === true">بله</td>
						<td v-else>خیر</td>
						<td class="persian-number">{{ item.stock_count }} {{ item.unit_fa }}</td>
						<td>{{ item.description }}</td>
						<td>
							<select
									style="border-radius: 8px; padding: 2px"
									v-model="item.active"
									@change="changeActiveWare(item)"
								>
									<option :value="true">فعال</option>
									<option :value="false">غیرفعال</option>
								</select>
						</td>
						<td>
							<img
								v-b-tooltip.hover
								title="تاریخچه انتقال"
								@click="transAction(item.id)"
								class="eye-icon"
								src="../../assets/images/iconPack/transaction.svg"
							/>
							<img
								v-b-tooltip.hover
								title="جزيیات"
								@click="action(item.id)"
								class="eye-icon mx-2"
								src="../../assets/images/iconPack/eye.svg"
							/>
							<img
								v-b-tooltip.hover
								title="ویرایش"
								@click="editData(item)"
								class="eye-icon icon-complement"
								src="../../assets/images/iconPack/basil_edit-outline.svg"
							/>
						</td>
					</tr>
				</template>
			</Tableview>
			<b-modal size="lg" v-model="editModal" hide-footer>
				<div class="d-flex mb-4">
					<div class="d-flex flex-column ml-3">
						<label for="html">نام فارسی</label>
						<input class="form-select" type="text" v-model="modalUserData.name_fa" />
					</div>
					<div class="d-flex flex-column ml-3">
						<label for="html">نام انگلیسی</label>
						<input class="form-select" type="text" v-model="modalUserData.name_en" />
					</div>
				</div>
				<div class="mb-3">
					<label for="html">توضیحات</label>
					<textarea v-model="modalUserData.description" class="textarea"></textarea>
				</div>
				<div class="d-flex justify-content-end align-items-end">
					<button @click="editBtn" class="accept">تایید</button>
					<button class="remove-filtes" @click="editModal = false">بستن</button>
				</div>
			</b-modal>
		</div>
	</div>
</template>
<script>
import Tableview from '../../components/Tableview/index.vue';
import Pagination from 'vue-pagination-2';

export default {
	components: {
		Tableview,
		Pagination,
	},
	data() {
		return {
			getDataLists: 0,
			wareType: [],
			pickTypes: '',
			totalDataCount: 0,
			page: 1,
			editModal: false,
			modalUserData: {},
		};
	},
	mounted() {
		this.getData();
		this.getWareType();
	},
	computed: {
		showContnetFunc() {
			return this.getDataLists === 0;
		},
		showDataFunc() {
			if (this.getDataLists.length !== undefined) {
				return this.getDataLists.length === 0;
			}
			return false;
		},
	},
	methods: {
		removeFilter() {
			this.pickTypes = '';
			this.getData();
		},
		async getWareType() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.WAREHOUSE_TYPE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
			);
			if (res.status === 200) {
				this.wareType = res.data;
			}
		},
		async getData(limit = 20, offset = 0) {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.WAREHOUSE_LIST +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&limit=' +
					limit +
					'&offset=' +
					offset +
					'&type=' +
					this.pickTypes,
				this.$PATH.SERVICE_NAME.EMPTY,
			);
			if (res.status === 200) {
				this.getDataLists = res.data.results;
				this.totalDataCount = res.data.count;
			}
		},
		async myCallback() {
			await this.getData(20, 20 * (this.page - 1));
		},
		transAction(id) {
			this.$router.push({ name: 'transactionList', params: { id: id } });
		},
		action(id) {
			this.$router.push({ name: 'wareDetail', params: { id: id } });
		},
		editData(item) {
			this.editModal = true;
			this.modalUserData = { ...item };
		},
		async editBtn() {
			const data = {
				name_fa: this.modalUserData.name_fa,
				name_en: this.modalUserData.name_en,
				description: this.modalUserData.description,
			};
			console.log(this.modalUserData.name_en);
			const res = await this.$ApiServiceLayer.patch(
				this.$PATH.RELATIVE_PATH.MULTI.WAREHOUSE_EDIT +
					this.modalUserData.id +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
				data,
			);
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'تغییرات با موفقیت اعمال شد!',
				});
				this.getData();
				this.editModal = false;
			}
		},
		async changeActiveWare(item) {
			const res = await this.$ApiServiceLayer.patch(
				this.$PATH.RELATIVE_PATH.MULTI.WAREHOUSE_EDIT + item.id + '/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
				{active:item.active}
			);
			console.log(res)
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'وضعیت با موفقیت تغییر پیدا کرد!',
				});
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.list-warehouse {
	padding: 32px 50px;
	.box {
		padding: 24px;
		border-radius: 8px;
		margin-bottom: 16px;
		background: #fff;
		border-radius: 8px;
		box-shadow: none;
		.search-input {
			text-indent: 10px;
			height: 40px;
			border: 1px solid #c4c4c4;
			padding: 0 9px;
			border-radius: 8px;
			font-family: 'IRANYekanfa' !important;
			border-radius: 8px;
			margin: 8px 0;
		}

		.eye-icon {
			width: 32px;
			cursor: pointer;
		}
		.persian-number {
			font-family: 'IRANYekanfa' !important;
		}
	}
}
.form-select {
	width: 100%;
	border: 1px solid #c4c4c4;
	height: 38px;
	padding: 0 9px;
	border-radius: 8px;
	color: #828282;
	border-radius: 8px;
}
.accept {
	height: 38px;
	background: #2d8b8b;
	border-radius: 8px;
	color: #fff;
	border: none !important;
	margin-left: 10px;
	width: 100px;
	border-radius: 8px;
	padding: 0 16px;
	min-width: 64px;
}
.remove-filtes {
	padding: 0 16px;
	border: 1px solid #2d8b8b;
	border-radius: 8px;
	color: #2d8b8b;
	height: 38px;
	background: #fff;
	border-radius: 8px;
	min-width: 64px;
}.textarea {
	border: 1px solid #c4c4c4;
	width: 100%;
	border-radius: 8px;
	min-height: 100px;
	padding: 10px;

}
</style>
<style>
.VuePagination__count {
	display: none;
}
.page-item.active .page-link {
	background-color: #2d8b8b;
	border-radius: 8px;
}
.page-link {
	border: none;
	color: black;
	font-family: 'IRANYekanfa' !important;
}
.vpd-icon-btn {
	display: none !important;
}
.vpd-input-group input {
	border: none !important;
	border-radius: 0;
	font-family: 'IRANYekanfa';
}
.vpd-input-group input:disabled {
	background: #fff;
	text-align: center;
	min-width: 130px;
}
</style>
